
    import {PageRequest} from '@/store/shared/entity'
    import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins,appConst } from "@/lib";

    class  PageAmountStatisticsRequest extends PageRequest{
        shipmentDate:[];
        chargeUserId:number;;
        businessGroup:string;
        customerId:number;
        salesType:string='ExportSales';
        senderId:number;
        tradingCountry:string;
        countryOfArrival:string;
    }

    @Component({
 name: "reportstatistics",
        components:{}
    })
    export default class AmountStatistics extends  Mixins(PageResultBaseMixins,PageResultModalMixins){
        buttons = { ...this.addBtn() };

        data:any = {
            model: new PageAmountStatisticsRequest(),
            queryAction:"reportstatistics/amountstatistics/getAll",
            isAutoQuery: true,
            cols:this.columns
        }

        get columns(){
            return [
                 this.$util.render.codeColumn("app.DeclareCustoms.BusinessGroup", "businessGroup", () => {return this.businessGroupList},{ width: 150 }),
                { title:this.L('app.UserAssignment.AssigneeUserId'), key:'chargeUser' ,width: 150},
                { title:this.L('app.DeclareCustoms.CustomerName'), key:'customerName',minWidth: 400 },
                {
                  title: this.L("app.DeclareCustoms.ReceiverAmount"),
                  key: "receiverAmount",
                  minWidth: 100,
                    render: (h: any, params: any) => {
                        if(this.data.model.salesType=="ExportSales"){
                            if(params.row.receiverAmount==null){
                                return [h("span", "N/A")];
                            }
                            else{
                                return [h("span", "$"+this.$util.format.amount(params.row.receiverAmount))];
                            }
                             
                        }
                        else{
                            return [h("span", "￥"+this.$util.format.amount(params.row.receiverAmount))];
                        }
                    }
                },  
                {
                  title: this.L("app.DeclareCustoms.CustomsDeclarationAmount"),
                  key: "customsDeclarationAmount",
                  minWidth: 100,
                    render: (h: any, params: any) => {
                        if(this.data.model.salesType=="ExportSales"){
                            if(params.row.customsDeclarationAmount==null){
                                return [h("span", "N/A")];
                            }
                            else{
                                return [h("span", "$"+this.$util.format.amount(params.row.customsDeclarationAmount))];
                            }
                             
                        }
                        else{
                            return [h("span", "￥"+this.$util.format.amount(params.row.customsDeclarationAmount))];
                        }
                    }
                }, 
                { title:this.L('app.AmountStatistics.TotalVotes'), key:'totalVotes',width: 200 },
            ]
        }

        async created(){
            // 不是业务组负责人，则默认查询单证为当前人
            if (!this.businessGroupOfCurrentUser) {
                if (this.userList && this.userList.findIndex(item => item.value === this.currentUser.id) > -1) {
                    this.$set(this.data.model, "chargeUserId", this.currentUser.id);
                }
            } else {
                if (this.businessGroupList && this.businessGroupList.findIndex(item => item.value === this.businessGroupOfCurrentUser) > -1) {
                    this.$set(this.data.model, "businessGroup", this.businessGroupOfCurrentUser);
                }
            }
            await this.$store.dispatch({type:'system/userassignment/getUser'})
            await this.$store.dispatch({type:'system/sender/getSenderList'})
        }
        // 当前人负责的业务组
  get businessGroupOfCurrentUser() {
    return this.$store.state.system.user.businessGroup;
  }
  get  currentUser() {
    return this.$store.state.currentUser.session.user;
  }
        get userList() {
    return this.$store.state.system.userassignment.userList;
  }
//客户列表
  get customerList() {
    return this.$store.state.system.customer.customerList;
  }

  // 业务组列表
  get businessGroupList() {
    return this.getCodeListByCategory(appConst.codeCategory.businessGroup)
  }
  get salesTypeList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.salesType)
  }
  get senderList() {
    return this.$store.state.system.sender.senderList;
  }
  get tradingCountryList() {
    return this.getCodeListByCategory(appConst.codeCategory.tradingCountry);
  }
  get countryOfArrivalList() {
    return this.getCodeListByCategory(appConst.codeCategory.countryOfArrival);
  }
        reset(){
            this.data.model = new PageAmountStatisticsRequest();
            // 不是业务组负责人，则默认查询单证为当前人
            if (!this.businessGroupOfCurrentUser) {
                if (this.userList && this.userList.findIndex(item => item.value === this.currentUser.id) > -1) {
                    this.$set(this.data.model, "chargeUserId", this.currentUser.id);
                }
            } else {
                if (this.businessGroupList && this.businessGroupList.findIndex(item => item.value === this.businessGroupOfCurrentUser) > -1) {
                    this.$set(this.data.model, "businessGroup", this.businessGroupOfCurrentUser);
                }
            }
        }
        summaryMethod({ columns, data }) {
    const sums = {};
    const totalText = this.L('app.AmountStatistics.AllRecordsTotal');
    const NA = 'N/A';
    columns.forEach((column, index) => {
        const key = column.key ? column.key : column.slot;
        if (index === 0 || index === 1 || index === 2) {
            sums[key] = {
                key,
                value: ''
            };
            return;
        }
        if (index === 3) {
            sums[key] = {
                key,
                value: totalText
            };
            return;
        }
        const values = data.map(item => Number(item[key]));
        let k=null;
        if(key==="receiverAmount"){
            values.forEach(element => {
                if(element===0){
                    k=NA;
                }
            });
        }

        if (!values.every(value => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                    return prev + curr;
                }else {
                    return prev;
                }
            }, 0);
            
            sums[key] = {
                key,
                value: key === "receiverAmount" || key === "customsDeclarationAmount" ? (this.data.model.salesType=="ExportSales"?(k===NA?k:"$"+ this.$util.format.amount(v)): "￥"+ this.$util.format.amount(v)): v
            };
        } else {
            sums[key] = {
                key,
                value: NA
            };
        }
    });

    return sums;
  }
    }
